import React from "react";
import Head from "next/head";

import Organistion from "./HotelSchema/organisation";
import Accomodation from "./HotelSchema/accomodation";
import Breadcrumb from "./HotelSchema/breadcrumb";
import LocalBusiness from "./HotelSchema/local-business";
import HotelSchema from "./HotelSchema/hotel-schema";
import LodgingReservation from "./HotelSchema/lodgingreservation";
import RestaurantSchema from "./HotelSchema/restaurant-schema";
import DeluxeRoomSchema from "./HotelSchema/deluxe-room-schema";
import ExecutiveRoomSchema from "./HotelSchema/executive-room-schema";
import FamilyRoomSchema from "./HotelSchema/family-room-schema";
import PremierRoomSchema from "./HotelSchema/premier-room-schema";

export default ({ name }) => {
  return (
    <Head>
      {name === "Organistion" && <Organistion />}
      {name === "Accomodation" && <Accomodation />}
      {name === "Breadcrumb" && <Breadcrumb />}
      {name === "LocalBusiness" && <LocalBusiness />}
      {name === "HotelSchema" && <HotelSchema />}
      {name === "LodgingReservation" && <LodgingReservation />}
      {name === "RestaurantSchema" && <RestaurantSchema />}
      {name === "DeluxeRoomSchema" && <DeluxeRoomSchema />}
      {name === "ExecutiveRoomSchema" && <ExecutiveRoomSchema />}
      {name === "FamilyRoomSchema" && <FamilyRoomSchema />}
      {name === "PremierRoomSchema" && <PremierRoomSchema />}
    </Head>
  );
};
